import type { IconSvgObject } from './types';

const BookmarkOff02Icon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.5 4.5L4.5 21.5L12 17.5L19.5 21.5V19.5M7 2.5H17.5C18.6046 2.5 19.5 3.39543 19.5 4.5V15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookmarkOff02Icon;
